import { Component, OnInit } from '@angular/core';
import { PreloaderService } from './utils/services/preloader.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { ErrorPopUpComponent } from './common/error-pop-up/error-pop-up.component';
import { ErrorsService } from './utils/services/errors.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  public flag = true;

  constructor(
    public loaderService: PreloaderService,
    private dialog: MatDialog,
    private errorsService: ErrorsService,
  ) {
    this.getErrorStatus();
  }

  ngOnInit() {
    this.loaderService.getLoader().subscribe(data => {
    });
  }

  getErrorStatus() {
    this.errorsService.getErrorStatus().subscribe(data => {
      if (data !== undefined) {
        if (this.dialog.openDialogs.length === 0) {
          const dialogRef = this.dialog.open(ErrorPopUpComponent, {
            width: '320px',
            data: data
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
            }
            this.flag = false;
          });
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts